import React, { useEffect, useState } from "react";
import {
  CustomLabel,
  DownloadTemplate,
  HeaderDivider,
  RightDivider,
} from "../../../../../utilities/utll";
import { Col, Row } from "reactstrap";
import { Button, Checkbox, Collapse, Input, message, Select } from "antd";
import { useTradeStore } from "../../../../../store/vendorRegistrationStore/useTradeStore";
import "../../../../../components/form/styles/form.module.css";
import ApproveReject from "../../../../../components/approveReject/ApproveReject";
import { CheckCircleFilled, DeleteOutlined, DownloadOutlined } from "@ant-design/icons";
import TurnOverTable from "./TurnOverTable";
import { useVendorMasterStore } from "../../../../../store/useVendorMasterStore";
import LuxuryCheckbox from "../../../../../common/Checkbox";
import FileUploadDragger from "../../../../../common/dragUpload";
import priceAndMarginSample from "../../../../../assets/sampleFiles/MARGIN_SHEET.xlsx";
import { uploadDocApi } from "../../../../../services/irn";
import { useIrnStore } from "../../../../../store/useIrnstore";
import { useBasicDataFormStore } from "../../../../../store/vendorRegistrationStore/useBasicDataFormStore";
import ImagePreviewModal from "../../../../IRNRegister/ListRegister/imageModal";

export const TradeSupportTermsForm = () => {
  const {
    tradeData,
    errors,
    handleInputChange,
    addTurnoverRow,
    updateTurnoverRow,
    removeTurnoverRow,
    deleteTradeFile,
  } = useTradeStore();

  console.log("tradeData",tradeData)
  const { basicData } = useBasicDataFormStore();
  const { checkBoxes, setCheckbox, editInStep4 } = useVendorMasterStore();
  const locationCode = localStorage.getItem("locationCode");
  const GUID = localStorage.getItem("vendorGUID");
  const { downloadDoc } = useIrnStore();
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [imageUrl, setImageUrl] = useState(null);
  const [fileName, setFileName] = useState("");
  const [fileType, setFileType] = useState("");
  console.log(basicData, "basicdata");

  const frequency = [
    "Monthly",
    "Quaterly",
    "Half-Yearly",
    "Yearly",
    "One Time",
  ];

  const method = ["By Debit", "By Stock", "By Cheque"];
  const yesAndNo = ["Yes", "No"];
  const submitted = localStorage.getItem("submitted") === "Yes";
  const approve = localStorage.getItem("showApprove") === "true";

  const methodOptions = method.map((t) => ({
    label: t,
    value: t,
  }));
  const frequencyOptions = frequency.map((t) => ({
    label: t,
    value: t,
  }));

  useEffect(() => {
    if (GUID && basicData?.locationCode) {
      handleInputChange("locationCode", basicData?.locationCode);
      handleInputChange("vendorGUID", GUID);
    }
  }, [basicData, GUID]);

  const allChecked = Object.values(checkBoxes).every(Boolean);

  // table funcnality

  const getLastThreeFY = () => {
    const currentYear = new Date().getFullYear();
    return [
      `${currentYear - 3}-${currentYear - 2}`,
      `${currentYear - 2}-${currentYear - 1}`,
      `${currentYear - 1}-${currentYear}`,
    ];
  };

  const turnOverYears = getLastThreeFY();
  const handleAddRow = () => {
    const success = addTurnoverRow();
    if (!success) {
      message.warning(
        "Please fill Financial Year and Turnover Amount before adding another row (Max 3 years allowed)",
      );
    }
  };

  const handleFileUpload = async (info, percent, type) => {
    let uploadedFile = info;

    if (!(uploadedFile instanceof File)) return;

    const originalName = uploadedFile.name;

    // 🔹 Sanitize filename (remove spaces & special chars)
    const sanitizedFileName = originalName
      .replace(/\s+/g, "") // remove spaces
      .replace(/[^a-zA-Z0-9_.-]/g, ""); // remove special chars

    uploadedFile = new File([uploadedFile], sanitizedFileName, {
      type: uploadedFile.type,
      lastModified: uploadedFile.lastModified,
    });
    try {
      const res = await uploadDocApi(uploadedFile, percent);
      if (res) {
        handleInputChange(type, res);
      }
    } catch (error) {
      console.error("File upload failed", error);
      message.error("File upload failed. Please try again.");
    }
  };

  const handleDownload = async (name) => {
    try {
      setLoading(true);

      const response = await downloadDoc(name); // MUST be arraybuffer

      const extension = name.split(".").pop().toLowerCase();

      // let mimeType = "application/octet-stream";
      let type = "other";

      if (["jpg", "JPG", "jpeg", "png", "webp"].includes(extension)) {
        type = "image";
      } else if (extension === "pdf") {
        type = "pdf";
      }

      setImageUrl(response);
      setFileName(name);
      setFileType(type);
      setOpen(true);
    } catch (error) {
      console.error("Download failed", error);
      message.error("Failed to download file");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <HeaderDivider title="TOT Incentive" />
      <Row style={{ marginTop: "20px" }}>
        <Col xl={3} lg={3} md={6} sm={12}>
          <CustomLabel
            children={"Turnover Incentive Amount(Rs)/Month"}
            isImportnt={true}
          />
          <Input
            type="text"
            placeholder="Enter Value"
            size="medium"
            value={tradeData?.turnoverIncentiveAmount}
            onChange={(e) => {
              const value = e.target.value;

              // Allow digits only
              if (/^\d*\.?\d{0,2}$/.test(value)) {
                handleInputChange("turnoverIncentiveAmount", Number(value));
              }
            }}
            disabled={!editInStep4}
          />
          {errors?.turnoverIncentiveAmount && (
            <span style={{ color: "red", fontSize: "12px" }}>
              {errors?.turnoverIncentiveAmount}
            </span>
          )}
        </Col>
        <Col xl={3} lg={3} md={6} sm={12}>
          <CustomLabel children={"% Turnover"} isImportnt={false} />
          <Input
            type="text"
            placeholder="Enter Value"
            size="medium"
            value={tradeData?.turnover}
            onChange={(e) => {
              const value = e.target.value;

              // Allow digits only
              if (/^\d*\.?\d{0,2}$/.test(value)) {
                handleInputChange("turnover", Number(value));
              }
            }}
            // onChange={(e) =>
            //   handleInputChange("turnover", Number(e.target.value))
            // }
            disabled={!editInStep4}
          />
        </Col>
        <Col xl={3} md={6}>
          <CustomLabel children={"Realization Frequency"} />
          <Select
            allowClear
            showSearch
            optionFilterProp="label"
            size="medium"
            style={{ width: "100%" }}
            options={frequency.map((t) => ({
              label: t,
              value: t,
            }))}
            value={tradeData?.turnoverRealizationFrequency}
            onChange={(val) =>
              handleInputChange("turnoverRealizationFrequency", val)
            }
            disabled={!editInStep4}
          />
          {errors?.turnoverRealizationFrequency && (
            <span style={{ color: "red", fontSize: "12px" }}>
              {errors?.turnoverRealizationFrequency}
            </span>
          )}
        </Col>
        <Col xl={3} md={6}>
          <CustomLabel children={"Realization Method"} isImportnt={false} />
          <Select
            placeholder="Select"
            allowClear
            showSearch
            optionFilterProp="label"
            size="medium"
            style={{ width: "100%" }}
            disabled={!editInStep4 || !tradeData?.turnoverRealizationFrequency}
            options={method.map((t) => ({
              label: t,
              value: t,
            }))}
            value={tradeData?.turnoverRealizationMethod}
            onChange={(val) =>
              handleInputChange("turnoverRealizationMethod", val)
            }
          />
          {tradeData?.turnoverRealizationFrequency &&
            errors?.turnoverRealizationMethod && (
              <span style={{ color: "red", fontSize: "12px" }}>
                {errors?.turnoverRealizationMethod}
              </span>
            )}
        </Col>
        {submitted && (
          <Col xl={3} lg={3} md={6} sm={12} style={{}}>
            <LuxuryCheckbox
              id={"totIncentives"}
              label="Checked"
              checked={checkBoxes.totIncentives}
              onChange={(e) =>
                setCheckbox("totIncentives", !checkBoxes.totIncentives)
              }
              disabled={!approve}
            />
          </Col>
        )}
      </Row>
      <div style={{ margin: "16px 0" }}>
        <HeaderDivider title="Last 3 Year's Turnover" />
        <TurnOverTable
          data={tradeData.lastThreeYearTurnover}
          turnOverYears={turnOverYears}
          addRow={handleAddRow}
          updateRow={updateTurnoverRow}
          removeRow={removeTurnoverRow}
          submitted={submitted}
          editInStep4={editInStep4}
        />
      </div>

      {/* <HeaderDivider title="Merchandising Support" /> */}
      <Collapse
        defaultActiveKey={[]}
        items={[
          {
            key: "1",
            label: "Merchandising Support",
            children: (
              <>
                <Row style={{ marginTop: "20px" }}>
                  <Col xl={2} lg={2} md={6} sm={12}>
                    <CustomLabel
                      children={"Amount(Rs) Person/Month"}
                      isImportnt={false}
                    />
                    <Input
                      type="text"
                      placeholder="Enter Value"
                      size="medium"
                      value={tradeData?.merchandisingAmountRsPerPerson}
                      onChange={(e) => {
                        const value = e.target.value;

                        // Allow only positive numbers with up to 2 decimals
                        if (/^\d*\.?\d{0,2}$/.test(value)) {
                          handleInputChange(
                            "merchandisingAmountRsPerPerson",
                            value,
                          );
                        }
                      }}
                      disabled={!editInStep4}
                    />
                  </Col>
                  <Col xl={2} lg={2} md={6} sm={12}>
                    <CustomLabel
                      children={"No of person per store"}
                      isImportnt={false}
                    />
                    <Input
                      type="text"
                      placeholder="Enter Value"
                      size="medium"
                      value={tradeData?.merchandisingNoOfPersonPerStore}
                      onChange={(e) => {
                        const value = e.target.value;

                        // Allow digits only
                        if (/^\d*$/.test(value)) {
                          handleInputChange(
                            "merchandisingNoOfPersonPerStore",
                            Number(e.target.value),
                          );
                        }
                      }}
                      disabled={!editInStep4}
                    />
                  </Col>
                  <Col xl={2} lg={2} md={6} sm={12}>
                    <CustomLabel
                      children={"% on Turnover"}
                      isImportnt={false}
                    />
                    <Input
                      type="text"
                      placeholder="Enter Value"
                      size="medium"
                      value={tradeData?.merchandisingOnTurnover}
                      onChange={(e) => {
                        const value = e.target.value;

                        // Allow digits only
                        if (/^\d*\.?\d{0,2}$/.test(value)) {
                          handleInputChange("merchandisingOnTurnover", value);
                        }
                      }}
                      disabled={!editInStep4}
                    />
                  </Col>
                  <Col xl={2} md={6}>
                    <CustomLabel children={"Realization Frequency"} />
                    <Select
                      placeholder="Select "
                      allowClear
                      showSearch
                      optionFilterProp="label"
                      size="medium"
                      style={{ width: "100%" }}
                      value={
                        tradeData?.merchandisingRealizationFrequency ||
                        undefined
                      }
                      onChange={(value) =>
                        handleInputChange(
                          "merchandisingRealizationFrequency",
                          value,
                        )
                      }
                      options={frequencyOptions}
                      disabled={!editInStep4}
                    />
                    {errors?.merchandisingRealizationFrequency && (
                      <span style={{ color: "red", fontSize: "12px" }}>
                        {errors?.merchandisingRealizationFrequency}
                      </span>
                    )}
                  </Col>
                  <Col xl={2} md={6}>
                    <CustomLabel children={"Realization Method"} />
                    <Select
                      placeholder="Select "
                      allowClear
                      showSearch
                      optionFilterProp="label"
                      size="medium"
                      style={{ width: "100%" }}
                      disabled={
                        !editInStep4 ||
                        !tradeData?.merchandisingRealizationFrequency
                      }
                      value={tradeData?.merchandisingRealizationMethod}
                      onChange={(value) =>
                        handleInputChange(
                          "merchandisingRealizationMethod",
                          value,
                        )
                      }
                      options={methodOptions}
                    />
                    {tradeData?.merchandisingRealizationFrequency &&
                      errors?.merchandisingRealizationMethod && (
                        <span style={{ color: "red", fontSize: "12px" }}>
                          {errors?.merchandisingRealizationMethod}
                        </span>
                      )}
                  </Col>
                </Row>
              </>
            ),
          },
        ]}
      />

      <Collapse
        defaultActiveKey={[]}
        style={{ marginTop: 10 }}
        items={[
          {
            key: "1",
            label: "Damage And Expiry",
            children: (
              <>
                <Row style={{ marginTop: "20px" }}>
                  <Col xl={3} md={6}>
                    <CustomLabel
                      children={"Stock Returnable By Gate Pass"}
                      isImportnt={true}
                    />
                    <Select
                      placeholder="Select "
                      allowClear
                      showSearch
                      optionFilterProp="label"
                      size="medium"
                      style={{ width: "100%" }}
                      options={yesAndNo.map((t) => ({
                        label: t,
                        value: t === "Yes" ? true : false,
                      }))}
                      value={tradeData?.damageStockReturnableByGatePass}
                      onChange={(value) =>
                        handleInputChange(
                          "damageStockReturnableByGatePass",
                          value,
                        )
                      }
                      disabled={!editInStep4}
                    />
                    {errors?.damageStockReturnableByGatePass && (
                      <span style={{ color: "red", fontSize: "12px" }}>
                        {errors?.damageStockReturnableByGatePass}
                      </span>
                    )}
                  </Col>
                  <Col xl={3} md={6}>
                    <CustomLabel
                      children={"Stock Replacement(One to One)"}
                      isImportnt={true}
                    />
                    <Select
                      placeholder="Select "
                      allowClear
                      showSearch
                      optionFilterProp="label"
                      size="medium"
                      style={{ width: "100%" }}
                      options={yesAndNo.map((t) => ({
                        label: t,
                        value: t === "Yes" ? true : false,
                      }))}
                      value={tradeData?.damageStockReplacement}
                      onChange={(value) =>
                        handleInputChange("damageStockReplacement", value)
                      }
                      status={errors?.damageStockReplacement ? "error" : ""}
                      disabled={!editInStep4}
                    />
                    {errors?.damageStockReplacement && (
                      <span style={{ color: "red", fontSize: "12px" }}>
                        {errors?.damageStockReplacement}
                      </span>
                    )}
                  </Col>
                  <Col xl={3} md={6}>
                    <CustomLabel
                      children={"Vendor Will Take Back Stocks"}
                      isImportnt={false}
                    />
                    <Select
                      placeholder="Select "
                      allowClear
                      showSearch
                      optionFilterProp="label"
                      size="medium"
                      style={{ width: "100%" }}
                      options={yesAndNo.map((t) => ({
                        label: t,
                        value: t === "Yes" ? true : false,
                      }))}
                      value={
                        tradeData?.damageVendorWillTakeBackStocks || undefined
                      }
                      onChange={(value) =>
                        handleInputChange(
                          "damageVendorWillTakeBackStocks",
                          value,
                        )
                      }
                      disabled={!editInStep4}
                    />
                  </Col>
                  <Col xl={3} md={6}>
                    <CustomLabel children={"Realization Method"} />
                    <Select
                      placeholder="Select "
                      allowClear
                      showSearch
                      optionFilterProp="label"
                      size="medium"
                      style={{ width: "100%" }}
                      options={method.map((t) => ({
                        label: t,
                        value: t,
                      }))}
                      value={tradeData?.damageRealizationMethod}
                      onChange={(value) =>
                        handleInputChange("damageRealizationMethod", value)
                      }
                      status={errors?.damageRealizationMethod ? "error" : ""}
                      disabled={!editInStep4}
                    />
                    {errors?.damageRealizationMethod && (
                      <span style={{ color: "red", fontSize: "12px" }}>
                        {errors?.damageRealizationMethod}
                      </span>
                    )}
                  </Col>
                </Row>
                <Row>
                  <Col xl={3} md={6}>
                    <CustomLabel
                      children={"Realization Frequency"}
                      isImportnt={false}
                    />
                    <Select
                      placeholder="Select "
                      allowClear
                      showSearch
                      optionFilterProp="label"
                      size="medium"
                      style={{ width: "100%" }}
                      options={frequency.map((t) => ({
                        label: t,
                        value: t,
                      }))}
                      value={tradeData?.damageRealizationFrequency || undefined}
                      onChange={(value) =>
                        handleInputChange("damageRealizationFrequency", value)
                      }
                      disabled={!editInStep4}
                    />
                  </Col>
                  <Col xl={6} lg={6} md={6} sm={12}>
                    <CustomLabel
                      children={
                        "No Stock Return or replacement But allowance as % on Turnover"
                      }
                      isImportnt={true}
                    />
                    <Input
                      type="text"
                      placeholder="Enter value"
                      size="medium"
                      value={
                        tradeData?.damageNoStockReturnOrReplacementButAllowance
                      }
                      onChange={(e) => {
                        const value = e.target.value;

                        // Allow only positive numbers with up to 2 decimals
                        if (/^\d*\.?\d{0,2}$/.test(value)) {
                          handleInputChange(
                            "damageNoStockReturnOrReplacementButAllowance",
                            value,
                          );
                        }
                      }}
                      status={
                        errors?.damageNoStockReturnOrReplacementButAllowance
                          ? "error"
                          : ""
                      }
                      disabled={!editInStep4}
                    />
                    {errors?.damageNoStockReturnOrReplacementButAllowance && (
                      <span style={{ color: "red", fontSize: "12px" }}>
                        {errors?.damageNoStockReturnOrReplacementButAllowance}
                      </span>
                    )}
                  </Col>
                  {submitted && (
                    <Col
                      xl={3}
                      lg={3}
                      md={6}
                      sm={12}
                      style={{
                        marginTop: 20,
                      }}
                    >
                      <LuxuryCheckbox
                        id={"damageAndExpiry"}
                        label="Checked"
                        checked={checkBoxes.damageAndExpiry}
                        onChange={(e) =>
                          setCheckbox(
                            "damageAndExpiry",
                            !checkBoxes.damageAndExpiry,
                          )
                        }
                        disabled={!approve}
                      />
                    </Col>
                  )}
                </Row>
              </>
            ),
          },
        ]}
      />
      {/* <HeaderDivider title="BarCode and Labelling Support" /> */}

      <Collapse
        defaultActiveKey={[]}
        style={{ marginTop: 10 }}
        items={[
          {
            key: "1",
            label: "BarCode and Labelling Support",
            children: (
              <>
                <Row style={{ marginTop: "20px" }}>
                  <Col xl={3} lg={3} md={6} sm={12}>
                    <CustomLabel
                      children={"Barcode Amount per quantity"}
                      isImportnt={false}
                    />
                    <Input
                      type="text"
                      placeholder="Enter Value"
                      size="medium"
                      value={tradeData?.barcodeAmountPerQuantity}
                      onChange={(e) => {
                        const value = e.target.value;

                        // Allow only positive numbers with up to 2 decimals
                        if (/^\d*\.?\d{0,2}$/.test(value)) {
                          handleInputChange("barcodeAmountPerQuantity", value);
                        }
                      }}
                      disabled={!editInStep4}
                    />
                  </Col>
                  <Col xl={3} lg={3} md={6} sm={12}>
                    <CustomLabel
                      children={"% on Turnover"}
                      isImportnt={false}
                    />
                    <Input
                      type="text"
                      placeholder="Enter Value"
                      size="medium"
                      value={tradeData?.barcodeOnTurnover}
                      onChange={(e) => {
                        const value = e.target.value;

                        // Allow only positive numbers with up to 2 decimals
                        if (/^\d*$/.test(value)) {
                          handleInputChange("barcodeOnTurnover", value);
                        }
                      }}
                      // onChange={(e) =>
                      //   handleInputChange("barcodeOnTurnover", e.target.value)
                      // }
                      disabled={!editInStep4}
                    />
                  </Col>
                  <Col xl={3} md={6}>
                    <CustomLabel
                      children={"Realization Frequency"}
                      isImportnt={false}
                    />
                    <Select
                      placeholder="Select "
                      allowClear
                      showSearch
                      optionFilterProp="label"
                      size="medium"
                      style={{ width: "100%" }}
                      options={frequency.map((t) => ({
                        label: t,
                        value: t,
                      }))}
                      value={tradeData?.barcodeRealizationFrequency}
                      onChange={(value) =>
                        handleInputChange("barcodeRealizationFrequency", value)
                      }
                      disabled={!editInStep4}
                    />
                  </Col>
                  <Col xl={3} md={6}>
                    <CustomLabel children={"Realization Method"} />
                    <Select
                      placeholder="Select "
                      allowClear
                      showSearch
                      optionFilterProp="label"
                      size="medium"
                      style={{ width: "100%" }}
                      options={method.map((t) => ({
                        label: t,
                        value: t,
                      }))}
                      value={tradeData?.barcodeRealizationMethod}
                      onChange={(value) =>
                        handleInputChange("barcodeRealizationMethod", value)
                      }
                      status={errors?.barcodeRealizationMethod ? "error" : ""}
                      disabled={!editInStep4}
                    />
                    {errors?.barcodeRealizationMethod && (
                      <span style={{ color: "red", fontSize: "12px" }}>
                        {errors?.barcodeRealizationMethod}
                      </span>
                    )}
                  </Col>
                </Row>
              </>
            ),
          },
        ]}
      />

      <Collapse
        defaultActiveKey={[]}
        style={{ marginTop: 10 }}
        items={[
          {
            key: "1",
            label: "New Product Introduction Fee",
            children: (
              <>
                <Row style={{ marginTop: "20px" }}>
                  <Col xl={3} lg={3} md={6} sm={12}>
                    <CustomLabel children={"Amount (Rs)"} isImportnt={false} />
                    <Input
                      type="text"
                      placeholder="Enter Amount (Rs)"
                      size="medium"
                      value={tradeData?.newProductAmount}
                      onChange={(e) => {
                        const value = e.target.value;

                        // Allow only positive numbers with up to 2 decimals
                        if (/^\d*\.?\d{0,2}$/.test(value)) {
                          handleInputChange("newProductAmount", value);
                        }
                      }}
                      // status={errors?.newProductAmount ? "error" : ""}
                      disabled={!editInStep4}
                    />
                    {errors?.newProductAmount && (
                      <span style={{ color: "red", fontSize: "12px" }}>
                        {errors?.newProductAmount}
                      </span>
                    )}
                  </Col>
                  <Col xl={3} lg={3} md={6} sm={12}>
                    <CustomLabel
                      children={"% on Turnover"}
                      isImportnt={false}
                    />
                    <Input
                      type="text"
                      placeholder="Enter Value"
                      size="medium"
                      value={tradeData?.newProductOnTurnover}
                      // onChange={(e) =>
                      //   handleInputChange("newProductOnTurnover", e.target.value)
                      // }
                      onChange={(e) => {
                        const value = e.target.value;

                        // Allow only positive numbers with up to 2 decimals
                        if (/^\d*$/.test(value)) {
                          handleInputChange("newProductOnTurnover", value);
                        }
                      }}
                      disabled={!editInStep4}
                    />
                  </Col>
                  <Col xl={3} md={6}>
                    <CustomLabel
                      children={"Realization Frequency"}
                      isImportnt={false}
                    />
                    <Select
                      placeholder="Select "
                      allowClear
                      showSearch
                      optionFilterProp="label"
                      size="medium"
                      style={{ width: "100%" }}
                      options={frequency.map((t) => ({
                        label: t,
                        value: t,
                      }))}
                      value={tradeData?.newProductRealizationFrequency}
                      onChange={(value) =>
                        handleInputChange(
                          "newProductRealizationFrequency",
                          value,
                        )
                      }
                      // status={errors?.newProductRealizationFrequency ? "error" : ""}
                      disabled={!editInStep4}
                    />
                    {errors?.newProductRealizationFrequency && (
                      <span style={{ color: "red", fontSize: "12px" }}>
                        {errors?.newProductRealizationFrequency}
                      </span>
                    )}
                  </Col>
                  <Col xl={3} md={6}>
                    <CustomLabel
                      children={"Realization Method"}
                      isImportnt={false}
                    />
                    <Select
                      placeholder="Select "
                      allowClear
                      showSearch
                      optionFilterProp="label"
                      size="medium"
                      style={{ width: "100%" }}
                      options={method.map((t) => ({
                        label: t,
                        value: t,
                      }))}
                      value={tradeData?.newProductRealizationMethod}
                      onChange={(value) =>
                        handleInputChange("newProductRealizationMethod", value)
                      }
                      // status={errors?.newProductRealizationMethod ? "error" : ""}
                      disabled={!editInStep4}
                    />
                    {errors?.newProductRealizationMethod && (
                      <span style={{ color: "red", fontSize: "12px" }}>
                        {errors?.newProductRealizationMethod}
                      </span>
                    )}
                  </Col>
                </Row>
              </>
            ),
          },
        ]}
      />

      {/* <HeaderDivider title="" /> */}

      <Collapse
        style={{ marginTop: 10 }}
        items={[
          {
            key: "1",
            label: "Store Opening Support",
            children: (
              <>
                <Row style={{ marginTop: "20px" }}>
                  {/* Amount per SKU */}
                  <Col xl={3} lg={4} md={6} sm={12}>
                    <CustomLabel children={"Amount/SKU"} isImportnt={false} />
                    <Input
                      type="text"
                      placeholder="Enter Amount/SKU"
                      size="medium"
                      value={tradeData?.storeOpeningAmountSKU}
                      onChange={(e) => {
                        const value = e.target.value;

                        // Allow only positive numbers with up to 2 decimals
                        if (/^\d*\.?\d{0,2}$/.test(value)) {
                          handleInputChange("storeOpeningAmountSKU", value);
                        }
                      }}
                      disabled={!editInStep4}
                    />
                  </Col>

                  {/* Realization Frequency */}
                  <Col xl={3} md={6}>
                    <CustomLabel
                      children={"Realization Frequency"}
                      isImportnt={false}
                    />
                    <Select
                      placeholder="Select"
                      allowClear
                      showSearch
                      optionFilterProp="label"
                      size="medium"
                      style={{ width: "100%" }}
                      options={frequency.map((t) => ({
                        label: t,
                        value: t,
                      }))}
                      value={tradeData?.storeOpeningRealizationFrequency}
                      onChange={(value) =>
                        handleInputChange(
                          "storeOpeningRealizationFrequency",
                          value,
                        )
                      }
                      disabled={!editInStep4}
                    />
                  </Col>

                  {/* Realization Method - REQUIRED */}
                  <Col xl={3} md={6}>
                    <CustomLabel children={"Realization Method"} />
                    <Select
                      placeholder="Select"
                      allowClear
                      showSearch
                      optionFilterProp="label"
                      size="medium"
                      style={{ width: "100%" }}
                      options={method.map((t) => ({
                        label: t,
                        value: t,
                      }))}
                      value={tradeData?.storeOpeningRealizationMethod}
                      onChange={(value) =>
                        handleInputChange(
                          "storeOpeningRealizationMethod",
                          value,
                        )
                      }
                      status={
                        errors?.storeOpeningRealizationMethod ? "error" : ""
                      }
                      disabled={!editInStep4}
                    />
                    {errors?.storeOpeningRealizationMethod && (
                      <span style={{ color: "red", fontSize: "12px" }}>
                        {errors?.storeOpeningRealizationMethod}
                      </span>
                    )}
                  </Col>
                </Row>
              </>
            ),
          },
        ]}
      />

      {/* <HeaderDivider title="" /> */}
      <Collapse
        defaultActiveKey={[]}
        style={{ marginTop: 10 }}
        items={[
          {
            key: "1",
            label: "Store Anniversary Support",
            children: (
              <>
                <Row style={{ marginTop: "20px" }}>
                  {/* Amount (Rs) Per Store */}
                  <Col xl={3} lg={4} md={6} sm={12}>
                    <CustomLabel
                      children={"Amount (Rs) Per Store"}
                      isImportnt={false}
                    />
                    <Input
                      type="text"
                      placeholder="Enter Amount (Rs) Per Store"
                      size="medium"
                      value={tradeData?.storeAnniversaryAmountPerStore}
                      onChange={(e) => {
                        const value = e.target.value;

                        // Allow only positive numbers with up to 2 decimals
                        if (/^\d*\.?\d{0,2}$/.test(value)) {
                          handleInputChange(
                            "storeAnniversaryAmountPerStore",
                            value,
                          );
                        }
                      }}
                      disabled={!editInStep4}
                    />
                  </Col>

                  {/* Realization Frequency */}
                  <Col xl={3} md={6}>
                    <CustomLabel
                      children={"Realization Frequency"}
                      isImportnt={false}
                    />
                    <Select
                      placeholder="Select"
                      allowClear
                      showSearch
                      optionFilterProp="label"
                      size="medium"
                      style={{ width: "100%" }}
                      options={frequency.map((t) => ({
                        label: t,
                        value: t,
                      }))}
                      value={tradeData?.storeAnniversaryRealizationFrequency}
                      onChange={(value) =>
                        handleInputChange(
                          "storeAnniversaryRealizationFrequency",
                          value,
                        )
                      }
                      disabled={!editInStep4}
                    />
                  </Col>

                  {/* Realization Method - REQUIRED */}
                  <Col xl={3} md={6}>
                    <CustomLabel children={"Realization Method"} />
                    <Select
                      placeholder="Select"
                      allowClear
                      showSearch
                      optionFilterProp="label"
                      size="medium"
                      style={{ width: "100%" }}
                      options={method.map((t) => ({
                        label: t,
                        value: t,
                      }))}
                      value={tradeData?.storeAnniversaryRealizationMethod}
                      onChange={(value) =>
                        handleInputChange(
                          "storeAnniversaryRealizationMethod",
                          value,
                        )
                      }
                      status={
                        errors?.storeAnniversaryRealizationMethod ? "error" : ""
                      }
                      disabled={!editInStep4}
                    />
                    {errors?.storeAnniversaryRealizationMethod && (
                      <span style={{ color: "red", fontSize: "12px" }}>
                        {errors?.storeAnniversaryRealizationMethod}
                      </span>
                    )}
                  </Col>
                </Row>
              </>
            ),
          },
        ]}
      />
      {/* <HeaderDivider title="Store Anniversary Support" /> */}

      {/* VENDOR LISTING FEES */}

      <Collapse
        defaultActiveKey={[]}
        style={{ marginTop: 10 }}
        items={[
          {
            key: "1",
            label: "Vendor Listing Fees",
            children: (
              <>
                <Row style={{ marginTop: "20px" }}>
                  <Col xl={4} lg={4} md={6} sm={12}>
                    <CustomLabel
                      children={"Listing Fees (INR)"}
                      isImportnt={false}
                    />
                    <Input
                      type="text"
                      placeholder="Enter Listing Fees (INR)"
                      size="medium"
                      value={tradeData?.listingFee}
                      // onChange={(e) =>
                      //   handleInputChange("listingFee", Number(e.target.value))
                      // }
                      onChange={(e) => {
                        const value = e.target.value;

                        // Allow only positive numbers with up to 2 decimals
                        if (/^\d*\.?\d*$/.test(value)) {
                          handleInputChange("listingFee", value);
                        }
                      }}
                      status={errors?.listingFee ? "error" : ""}
                      disabled={!editInStep4}
                    />
                    {errors?.listingFee && (
                      <span style={{ color: "red", fontSize: "12px" }}>
                        {errors?.listingFee}
                      </span>
                    )}
                  </Col>
                </Row>
              </>
            ),
          },
        ]}
      />

      <Collapse
        defaultActiveKey={[]}
        style={{ marginTop: 10 }}
        items={[
          {
            key: "1",
            label: "Shrink Sharing",
            children: (
              <>
                <Row style={{ marginTop: "20px" }}>
                  {/* Shrink Sharing */}
                  <Col xl={4} md={6}>
                    <CustomLabel
                      children={"Shrink Sharing"}
                      isImportnt={false}
                    />
                    <Select
                      placeholder="Select"
                      allowClear
                      showSearch
                      optionFilterProp="label"
                      size="medium"
                      style={{ width: "100%" }}
                      options={yesAndNo.map((t) => ({
                        label: t,
                        value: t === "Yes" ? true : false,
                      }))}
                      value={tradeData?.shrinkSharing}
                      onChange={(value) =>
                        handleInputChange("shrinkSharing", value)
                      }
                      disabled={!editInStep4}
                    />
                  </Col>

                  {/* % Turnover */}
                  <Col xl={4} lg={4} md={6} sm={12}>
                    <CustomLabel children={"% Turnover"} isImportnt={false} />
                    <Input
                      type="text"
                      placeholder="Enter % Turnover"
                      size="medium"
                      value={tradeData?.shrinkSharingTurnover}
                      // onChange={(e) =>
                      //   handleInputChange("shrinkSharingTurnover", Number(e.target.value))
                      // }
                      onChange={(e) => {
                        const value = e.target.value;

                        // Allow only positive numbers decimals
                        if (/^\d*\.?\d*$/.test(value)) {
                          handleInputChange("shrinkSharingTurnover", value);
                        }
                      }}
                      disabled={!editInStep4}
                    />
                  </Col>
                </Row>
              </>
            ),
          },
        ]}
      />

      {/* <HeaderDivider title="Vendor Listing Fees" /> */}

      {/* SHRINK SHARING */}
      {/* <HeaderDivider title="Shrink Sharing" /> */}

      {/* ANY OTHER TRADING SUPPORT */}
      <Collapse
        defaultActiveKey={[]}
        style={{ marginTop: 10 }}
        items={[
          {
            key: "1",
            label: "Any Other Trading Support in lieu of consideration",
            children: (
              <>
                <RightDivider title="Option -1" />

                <Row style={{ marginTop: "20px" }}>
                  {/* Description */}
                  <Col xl={3} lg={3} md={6}>
                    <CustomLabel children={"Description"} isImportnt={false} />
                    <Input
                      type="text"
                      placeholder="Enter Description"
                      size="medium"
                      value={tradeData?.anyOtherOP1Desc}
                      onChange={(e) =>
                        handleInputChange("anyOtherOP1Desc", e.target.value)
                      }
                      disabled={!editInStep4}
                    />
                  </Col>

                  {/* Consideration Amount */}
                  <Col xl={3} lg={3} md={6}>
                    <CustomLabel
                      children={"Consideration Amount"}
                      isImportnt={false}
                    />
                    <Input
                      type="text"
                      placeholder="Enter Consideration Amount"
                      size="medium"
                      value={tradeData?.anyOtherOP1ConsiderationAmount}
                      onChange={(e) => {
                        const value = e.target.value;

                        // Allow only positive numbers with up to 2 decimals
                        if (/^\d*\.?\d{0,2}$/.test(value)) {
                          handleInputChange(
                            "anyOtherOP1ConsiderationAmount",
                            value,
                          );
                        }
                      }}
                      disabled={!editInStep4}
                    />
                  </Col>

                  {/* Realization Frequency */}
                  <Col xl={3} md={6}>
                    <CustomLabel
                      children={"Realization Frequency"}
                      isImportnt={false}
                    />
                    <Select
                      placeholder="Select"
                      allowClear
                      showSearch
                      optionFilterProp="label"
                      size="medium"
                      style={{ width: "100%" }}
                      options={frequencyOptions}
                      value={tradeData?.anyOtherOP1RealizationFrequency}
                      onChange={(value) =>
                        handleInputChange(
                          "anyOtherOP1RealizationFrequency",
                          value,
                        )
                      }
                      disabled={!editInStep4}
                    />
                  </Col>

                  {/* Realization Method - REQUIRED */}
                  <Col xl={3} md={6}>
                    <CustomLabel children={"Realization Method"} />
                    <Select
                      placeholder="Select"
                      allowClear
                      showSearch
                      optionFilterProp="label"
                      size="medium"
                      style={{ width: "100%" }}
                      options={methodOptions}
                      value={tradeData?.anyOtherOP1RealizationMethod}
                      onChange={(value) =>
                        handleInputChange("anyOtherOP1RealizationMethod", value)
                      }
                      status={
                        errors?.anyOtherOP1RealizationMethod ? "error" : ""
                      }
                      disabled={!editInStep4}
                    />
                    {errors?.anyOtherOP1RealizationMethod && (
                      <span style={{ color: "red", fontSize: "12px" }}>
                        {errors?.anyOtherOP1RealizationMethod}
                      </span>
                    )}
                  </Col>
                </Row>

                {/* OPTION 2 */}
                <RightDivider title="Option -2" />

                <Row style={{ marginTop: "20px" }}>
                  {/* Description */}
                  <Col xl={3} lg={3} md={6}>
                    <CustomLabel children={"Description"} isImportnt={false} />
                    <Input
                      type="text"
                      placeholder="Enter Description"
                      size="medium"
                      value={tradeData?.anyOtherOP2Desc}
                      onChange={(e) =>
                        handleInputChange("anyOtherOP2Desc", e.target.value)
                      }
                      disabled={!editInStep4}
                    />
                  </Col>

                  {/* Consideration Amount */}
                  <Col xl={3} lg={3} md={6}>
                    <CustomLabel
                      children={"Consideration Amount"}
                      isImportnt={false}
                    />
                    <Input
                      type="text"
                      placeholder="Enter Consideration Amount"
                      size="medium"
                      value={tradeData?.anyOtherOP2ConsiderationAmount}
                      onChange={(e) => {
                        const value = e.target.value;

                        // Allow only positive numbers with up to 2 decimals
                        if (/^\d*\.?\d{0,2}$/.test(value)) {
                          handleInputChange(
                            "anyOtherOP2ConsiderationAmount",
                            value,
                          );
                        }
                      }}
                      disabled={!editInStep4}
                    />
                  </Col>

                  {/* Realization Frequency */}
                  <Col xl={3} md={6}>
                    <CustomLabel
                      children={"Realization Frequency"}
                      isImportnt={false}
                    />
                    <Select
                      placeholder="Select"
                      allowClear
                      showSearch
                      optionFilterProp="label"
                      size="medium"
                      style={{ width: "100%" }}
                      options={frequencyOptions}
                      value={tradeData?.anyOtherOP2RealizationFrequency}
                      onChange={(value) =>
                        handleInputChange(
                          "anyOtherOP2RealizationFrequency",
                          value,
                        )
                      }
                      disabled={!editInStep4}
                    />
                  </Col>

                  {/* Realization Method - REQUIRED */}
                  <Col xl={3} md={6}>
                    <CustomLabel children={"Realization Method"} />
                    <Select
                      placeholder="Select"
                      allowClear
                      showSearch
                      optionFilterProp="label"
                      size="medium"
                      style={{ width: "100%" }}
                      options={methodOptions}
                      value={tradeData?.anyOtherOP2RealizationMethod}
                      onChange={(value) =>
                        handleInputChange("anyOtherOP2RealizationMethod", value)
                      }
                      status={
                        errors?.anyOtherOP2RealizationMethod ? "error" : ""
                      }
                      disabled={!editInStep4}
                    />
                    {errors?.anyOtherOP2RealizationMethod && (
                      <span style={{ color: "red", fontSize: "12px" }}>
                        {errors?.anyOtherOP2RealizationMethod}
                      </span>
                    )}
                  </Col>
                </Row>

                {/* OPTION 3 */}
                <RightDivider title="Option -3" />

                <Row style={{ marginTop: "20px" }}>
                  {/* Description */}
                  <Col xl={3} lg={3} md={6}>
                    <CustomLabel children={"Description"} isImportnt={false} />
                    <Input
                      type="text"
                      placeholder="Enter Description"
                      size="medium"
                      value={tradeData?.anyOtherOP3Desc}
                      onChange={(e) =>
                        handleInputChange("anyOtherOP3Desc", e.target.value)
                      }
                      disabled={!editInStep4}
                    />
                  </Col>

                  {/* Consideration Amount */}
                  <Col xl={3} lg={3} md={6}>
                    <CustomLabel
                      children={"Consideration Amount"}
                      isImportnt={false}
                    />
                    <Input
                      type="text"
                      placeholder="Enter Consideration Amount"
                      size="medium"
                      value={tradeData?.anyOtherOP3ConsiderationAmount}
                      onChange={(e) => {
                        const value = e.target.value;

                        // Allow only positive numbers with up to 2 decimals
                        if (/^\d*\.?\d{0,2}$/.test(value)) {
                          handleInputChange(
                            "anyOtherOP3ConsiderationAmount",
                            value,
                          );
                        }
                      }}
                      disabled={!editInStep4}
                    />
                  </Col>

                  {/* Realization Frequency */}
                  <Col xl={3} md={6}>
                    <CustomLabel
                      children={"Realization Frequency"}
                      isImportnt={false}
                    />
                    <Select
                      placeholder="Select"
                      allowClear
                      showSearch
                      optionFilterProp="label"
                      size="medium"
                      style={{ width: "100%" }}
                      options={frequencyOptions}
                      value={tradeData?.anyOtherOP3RealizationFrequency}
                      onChange={(value) =>
                        handleInputChange(
                          "anyOtherOP3RealizationFrequency",
                          value,
                        )
                      }
                      disabled={!editInStep4}
                    />
                  </Col>

                  {/* Realization Method - REQUIRED */}
                  <Col xl={3} md={6}>
                    <CustomLabel children={"Realization Method"} />
                    <Select
                      placeholder="Select"
                      allowClear
                      showSearch
                      optionFilterProp="label"
                      size="medium"
                      style={{ width: "100%" }}
                      options={methodOptions}
                      value={tradeData?.anyOtherOP3RealizationMethod}
                      onChange={(value) =>
                        handleInputChange("anyOtherOP3RealizationMethod", value)
                      }
                      status={
                        errors?.anyOtherOP3RealizationMethod ? "error" : ""
                      }
                      disabled={!editInStep4}
                    />
                    {errors?.anyOtherOP3RealizationMethod && (
                      <span style={{ color: "red", fontSize: "12px" }}>
                        {errors?.anyOtherOP3RealizationMethod}
                      </span>
                    )}
                  </Col>
                </Row>
              </>
            ),
          },
        ]}
      />
      {/* <HeaderDivider title="Any Other Trading Support in lieu of consideration" /> */}

      {/* OPTION 1 */}

      <Collapse
        defaultActiveKey={[]}
        style={{ marginTop: 10 }}
        items={[
          {
            key: "1",
            label: "Price & Margin Structure",
            children: (
              <>
                <Row style={{ marginTop: "20px", marginBottom: 20 }}>
                  <Col>
                    <FileUploadDragger
                      value={tradeData?.priceAndMargin}
                      onChange={(info, percent, type) =>
                        handleFileUpload(info, percent, "priceAndMargin")
                      }
                      type="priceAndMargin"
                      onRemove={() => handleInputChange("priceAndMargin", "")}
                      disabled={!editInStep4}
                    />
                  </Col>
                  <Col>
                    <div>
                      <Button
                        color="purple"
                        icon={<DownloadOutlined />}
                        disabled={!editInStep4}
                        variant="solid"
                        onClick={() =>
                          DownloadTemplate(
                            priceAndMarginSample,
                            "MARGIN_SHEET.xlsx",
                          )
                        }
                      >
                        Download Template
                      </Button>
                    </div>
                    {tradeData?.priceAndMargin && (
                       <div
                        style={{
                          display: "flex",
                          alignItems: "center",

                          gap: "20px",
                        }}
                      >
                      <a
                        style={{
                          color: "#1890ff",
                          cursor: "pointer",
                          textDecoration: "underline",
                          marginTop: 10,
                        }}
                        onClick={() =>
                          handleDownload(tradeData?.priceAndMargin)
                        }
                      >
                        View File
                      </a>
                      {approve && (
                          <DeleteOutlined
                            style={{
                              color: "#ff4d4f",
                              fontSize: "16px",
                              cursor: "pointer",
                            }}
                            title="Delete File"
                            onClick={() =>
                              deleteTradeFile("priceAndMargin")
                            }
                          />
                        )}
                      </div>
                    )}
                  </Col>
                  {/* {submitted && (
                    <Col
                      xl={2}
                      lg={2}
                      md={6}
                      sm={12}
                      style={{
                        marginBottom: 0,
                        paddingBottom: 0,
                        paddingTop: 0,
                        lineHeight: 1,
                      }}
                    >
                      <LuxuryCheckbox
                        id={"priceAndMargin"}
                        label="Checked"
                        checked={checkBoxes.priceAndMargin}
                        onChange={(e) =>
                          setCheckbox(
                            "priceAndMargin",
                            !checkBoxes.priceAndMargin
                          )
                        }
                        disabled={!approve}
                      />
                    </Col>
                  )} */}
                </Row>
              </>
            ),
          },
        ]}
      />

      <Collapse
        style={{ marginTop: "10px" }}
        defaultActiveKey={[]}
        items={[
          {
            key: "1",
            label: "TOT Agreement",
            children: (
              <>
                <Row style={{ marginTop: "20px" }}>
                  <Col xl={5} lg={5}>
                    <FileUploadDragger
                      value={tradeData?.totAgreement}
                      onChange={(info, percent, type) =>
                        handleFileUpload(info, percent, "totAgreement")
                      }
                      type="totAgreement"
                      onRemove={() => handleInputChange("totAgreement", "")}
                      disabled={!editInStep4}
                    />
                  </Col>
                  <Col xl={3} lg={3}>
                    <div></div>
                    {tradeData?.totAgreement && (
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",

                          gap: "20px",
                        }}
                      >
                        <a
                          style={{
                            color: "#1890ff",
                            cursor: "pointer",
                            textDecoration: "underline",
                            marginTop: 10,
                          }}
                          onClick={() =>
                            handleDownload(tradeData?.totAgreement)
                          }
                        >
                          View File
                        </a>
                        {approve && (
                          <DeleteOutlined
                            style={{
                              color: "#ff4d4f",
                              fontSize: "16px",
                              cursor: "pointer",
                            }}
                            title="Delete File"
                            onClick={() =>
                              deleteTradeFile("totAgreement")
                            }
                          />
                        )}
                      </div>
                    )}
                  </Col>
                </Row>
              </>
            ),
          },
        ]}
      />

      {submitted && approve && !editInStep4 && (
        <ApproveReject checked={allChecked} />
      )}

      {open && (
        <ImagePreviewModal
          open={open}
          onClose={() => {
            setOpen(false);
            setImageUrl(null);
            setFileName("");
            setFileType("");
          }}
          imageUrl={imageUrl}
          fileName={fileName}
          fileType={fileType}
        />
      )}
    </>
  );
};
